// AUTO-GENERATED by scripts/scrape-rankings.mjs from evwsports.com/rankings/ — do not hand-edit.
// Official East vs West rankings: every weight class, both arms, with champions.

export interface RankAthlete { rank: number; name: string; country: string; champion?: boolean; vacant?: boolean }
export interface WeightClassRanking {
  className: string;
  weight: string;
  arms: { right?: RankAthlete[]; left?: RankAthlete[] };
}

export const RANKINGS_OFFICIAL: WeightClassRanking[] = [
  {
    "className": "Super Heavyweight",
    "weight": "(115kg / 254lb) PLUS",
    "arms": {
      "right": [
        {
          "rank": 1,
          "name": "",
          "country": "",
          "vacant": true
        },
        {
          "rank": 2,
          "name": "Devon Larratt",
          "country": "Canada"
        },
        {
          "rank": 3,
          "name": "Artyom Morozov",
          "country": "Kazakhstan"
        },
        {
          "rank": 4,
          "name": "Ermes Gasparini",
          "country": "Italy"
        },
        {
          "rank": 5,
          "name": "Vitaly Laletin",
          "country": "Russia"
        },
        {
          "rank": 6,
          "name": "Kamil Jablonski",
          "country": "Poland"
        },
        {
          "rank": 7,
          "name": "Jerry Cadorette",
          "country": "USA"
        },
        {
          "rank": 8,
          "name": "Alex Kurdecha",
          "country": "Poland"
        },
        {
          "rank": 9,
          "name": "Georgi Tsvetkov",
          "country": "Bulgaria"
        },
        {
          "rank": 10,
          "name": "Georgii Dzeranov",
          "country": "Kazakhstan"
        }
      ],
      "left": [
        {
          "rank": 1,
          "name": "Vitaly Laletin",
          "country": "Russia",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Alizhan Muratov",
          "country": "Kazakhstan"
        },
        {
          "rank": 3,
          "name": "Artyom Morozov",
          "country": "Kazakhstan"
        },
        {
          "rank": 4,
          "name": "David Dadikyan",
          "country": "Armenia"
        },
        {
          "rank": 5,
          "name": "Devon Larratt",
          "country": "Canada"
        },
        {
          "rank": 6,
          "name": "Tobias Sporrong",
          "country": "Sweden"
        },
        {
          "rank": 7,
          "name": "Alex Kurdecha",
          "country": "Poland"
        },
        {
          "rank": 8,
          "name": "Ivan Matyushenko",
          "country": "Russia"
        },
        {
          "rank": 9,
          "name": "Kamil Jablonski",
          "country": "Poland"
        },
        {
          "rank": 10,
          "name": "Georgii Dzeranov",
          "country": "Kazakhstan"
        }
      ]
    }
  },
  {
    "className": "Heavyweight",
    "weight": "(115kg / 254lb)",
    "arms": {
      "right": [
        {
          "rank": 2,
          "name": "Dave Chaffee",
          "country": "USA"
        },
        {
          "rank": 3,
          "name": "Ibragim Sagov",
          "country": "Russia"
        },
        {
          "rank": 4,
          "name": "Yordan Tsonev",
          "country": "Bulgaria"
        },
        {
          "rank": 5,
          "name": "Serhii Kalinichenko",
          "country": "Ukraine"
        },
        {
          "rank": 6,
          "name": "Frank Lamparelli",
          "country": "Italy"
        },
        {
          "rank": 7,
          "name": "Sandris Šēdis",
          "country": "Latvia"
        },
        {
          "rank": 8,
          "name": "Matt Mask",
          "country": "Canada"
        },
        {
          "rank": 9,
          "name": "Lachlan Adair",
          "country": "Australia"
        },
        {
          "rank": 10,
          "name": "Lars Rørbakken",
          "country": "Norway"
        }
      ],
      "left": [
        {
          "rank": 1,
          "name": "Alizhan Muratov",
          "country": "Kazakhstan",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Devon Larratt",
          "country": "Canada"
        },
        {
          "rank": 3,
          "name": "Ivan Matyushenko",
          "country": "Russia"
        },
        {
          "rank": 4,
          "name": "Yordan Tsonev",
          "country": "Bulgaria"
        },
        {
          "rank": 5,
          "name": "Evgeny Prudnik",
          "country": "Ukraine"
        },
        {
          "rank": 6,
          "name": "Rino Mašić",
          "country": "Croatia"
        },
        {
          "rank": 7,
          "name": "Sandris Šēdis",
          "country": "Latvia"
        },
        {
          "rank": 8,
          "name": "Efe Kömek",
          "country": "Türkiye"
        },
        {
          "rank": 9,
          "name": "Davit Arabuli",
          "country": "Georgia"
        },
        {
          "rank": 10,
          "name": "Marcio Barboza",
          "country": "Brazil"
        }
      ]
    }
  },
  {
    "className": "Light Heavyweight",
    "weight": "(105kg / 232lb)",
    "arms": {
      "right": [
        {
          "rank": 1,
          "name": "",
          "country": "",
          "vacant": true
        },
        {
          "rank": 2,
          "name": "Oleg Petrenko",
          "country": "Ukraine"
        },
        {
          "rank": 3,
          "name": "David Dadikyan",
          "country": "Armenia"
        },
        {
          "rank": 4,
          "name": "Todd Hutchings",
          "country": "USA"
        },
        {
          "rank": 5,
          "name": "Krasimir Kostadinov",
          "country": "Bulgaria"
        },
        {
          "rank": 6,
          "name": "Nugzari Chikadze",
          "country": "Georgia"
        },
        {
          "rank": 7,
          "name": "Bogdan Stoica",
          "country": "Romania"
        },
        {
          "rank": 8,
          "name": "Matt Mask",
          "country": "Canada"
        },
        {
          "rank": 9,
          "name": "Irakli Zirakashvili",
          "country": "Georgia"
        },
        {
          "rank": 10,
          "name": "Yoshinobu Kanai",
          "country": "Japan"
        }
      ],
      "left": [
        {
          "rank": 1,
          "name": "Alizhan Muratov",
          "country": "Kazakhstan",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Evgeny Prudnik",
          "country": "Ukraine"
        },
        {
          "rank": 3,
          "name": "David Dadikyan",
          "country": "Armenia"
        },
        {
          "rank": 4,
          "name": "Oleg Petrenko",
          "country": "Ukraine"
        },
        {
          "rank": 5,
          "name": "Aymeric Pradines",
          "country": "France"
        },
        {
          "rank": 6,
          "name": "Oleg Zhokh",
          "country": "Ukraine"
        },
        {
          "rank": 7,
          "name": "Zurab Tavberidze",
          "country": "Georgia"
        },
        {
          "rank": 8,
          "name": "Jonathan Breda",
          "country": "USA"
        },
        {
          "rank": 9,
          "name": "Robbie Topie",
          "country": "USA"
        },
        {
          "rank": 10,
          "name": "Matt Mask",
          "country": "Canada"
        }
      ]
    }
  },
  {
    "className": "Middleweight",
    "weight": "(95kg / 209lb)",
    "arms": {
      "right": [
        {
          "rank": 1,
          "name": "Bogdan Stoica",
          "country": "Romania",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Todd Hutchings",
          "country": "USA"
        },
        {
          "rank": 3,
          "name": "Irakli Zirakashvili",
          "country": "Georgia"
        },
        {
          "rank": 4,
          "name": "Rustam Babaiev",
          "country": "Ukraine"
        },
        {
          "rank": 5,
          "name": "Eldar Bubenko",
          "country": "Russia"
        },
        {
          "rank": 6,
          "name": "Paul Linn",
          "country": "USA"
        },
        {
          "rank": 7,
          "name": "Georgii Tautiev",
          "country": "Russia"
        },
        {
          "rank": 8,
          "name": "Bacho Saginashvili",
          "country": "Georgia"
        },
        {
          "rank": 9,
          "name": "Davit Samushia",
          "country": "Georgia"
        },
        {
          "rank": 10,
          "name": "Adam Wawrzynski",
          "country": "USA"
        }
      ],
      "left": [
        {
          "rank": 1,
          "name": "Oleg Petrenko",
          "country": "Ukraine",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Betkili Oniani",
          "country": "Georgia"
        },
        {
          "rank": 3,
          "name": "Oleg Zhokh",
          "country": "Ukraine"
        },
        {
          "rank": 4,
          "name": "Rustam Babaiev",
          "country": "Ukraine"
        },
        {
          "rank": 5,
          "name": "Artem Taynov",
          "country": "Russia"
        },
        {
          "rank": 6,
          "name": "Zurab Tavberidze",
          "country": "Georgia"
        },
        {
          "rank": 7,
          "name": "Talgat Aktaev",
          "country": "Kazakhstan"
        },
        {
          "rank": 8,
          "name": "Maayan Shterengas",
          "country": "Israel"
        },
        {
          "rank": 9,
          "name": "Jason Merlo",
          "country": "USA"
        },
        {
          "rank": 10,
          "name": "Oleksandr Telyatnik",
          "country": "Ukraine"
        }
      ]
    }
  },
  {
    "className": "Welterweight",
    "weight": "(85kg / 187lb)",
    "arms": {
      "right": [
        {
          "rank": 1,
          "name": "Oleksandr Telyatnik",
          "country": "Ukraine",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Davit Samushia",
          "country": "Georgia"
        },
        {
          "rank": 3,
          "name": "Nurdaulet Aidarkhan",
          "country": "Kazakhstan"
        },
        {
          "rank": 4,
          "name": "Vladimir Maiorov",
          "country": "Russia"
        },
        {
          "rank": 5,
          "name": "Abdulmanaf Tuzuyev",
          "country": "Kazakhstan"
        },
        {
          "rank": 6,
          "name": "Vladislav Krasovskis",
          "country": "Latvia"
        },
        {
          "rank": 7,
          "name": "Tim Tallmadge",
          "country": "USA"
        },
        {
          "rank": 8,
          "name": "Vala Ichqiti",
          "country": "Georgia"
        },
        {
          "rank": 9,
          "name": "Adam Wawrzynski",
          "country": "USA"
        },
        {
          "rank": 10,
          "name": "Janis Amolins",
          "country": "Latvia"
        }
      ],
      "left": [
        {
          "rank": 1,
          "name": "Oleg Zhokh",
          "country": "Ukraine",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Vrezh Sedrakyan",
          "country": "Armenia"
        },
        {
          "rank": 3,
          "name": "Daniel Procopciuc",
          "country": "Moldova"
        },
        {
          "rank": 4,
          "name": "Luka Tsinadze",
          "country": "Georgia"
        },
        {
          "rank": 5,
          "name": "Avtandil Tutberidze",
          "country": "Georgia"
        },
        {
          "rank": 6,
          "name": "Paul Talbott",
          "country": "USA"
        },
        {
          "rank": 7,
          "name": "Toms Rozits",
          "country": "Latvia"
        },
        {
          "rank": 8,
          "name": "Artem Taranenko",
          "country": "USA"
        }
      ]
    }
  },
  {
    "className": "Lightweight",
    "weight": "(77kg / 170lb)",
    "arms": {
      "right": [
        {
          "rank": 1,
          "name": "Oleg Cherkasov",
          "country": "Russia",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Artur Makarov",
          "country": "Russia"
        },
        {
          "rank": 3,
          "name": "Mindaugas Tarasaitis",
          "country": "Lithuania"
        },
        {
          "rank": 4,
          "name": "Daniel Procopciuc",
          "country": "Moldova"
        },
        {
          "rank": 5,
          "name": "Ömer Kozakoğlu",
          "country": "Türkiye"
        },
        {
          "rank": 6,
          "name": "Janis Amolins",
          "country": "Latvia"
        },
        {
          "rank": 7,
          "name": "Tom Holland",
          "country": "UK"
        },
        {
          "rank": 8,
          "name": "Justin Bishop",
          "country": "USA"
        },
        {
          "rank": 9,
          "name": "Danil Ustinov",
          "country": "Kazakhstan"
        },
        {
          "rank": 10,
          "name": "Hunter Noffz",
          "country": "USA"
        }
      ],
      "left": [
        {
          "rank": 1,
          "name": "Daniel Procopciuc",
          "country": "Moldova",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Mindaugas Tarasaitis",
          "country": "Lithuania"
        },
        {
          "rank": 3,
          "name": "Vachagan Hovhannisyan",
          "country": "Armenia"
        },
        {
          "rank": 4,
          "name": "Emil Amirshadyan",
          "country": "Armenia"
        },
        {
          "rank": 5,
          "name": "Bozhidar Simeonov",
          "country": "Bulgaria"
        },
        {
          "rank": 6,
          "name": "Hunter Noffz",
          "country": "USA"
        }
      ]
    }
  },
  {
    "className": "Featherweight",
    "weight": "(70kg / 154lb)",
    "arms": {
      "right": [
        {
          "rank": 1,
          "name": "Danil Ustinov",
          "country": "Kazakhstan",
          "champion": true
        },
        {
          "rank": 2,
          "name": "Joseph Meranto",
          "country": "USA"
        },
        {
          "rank": 3,
          "name": "Valen Low",
          "country": "Singapore"
        },
        {
          "rank": 4,
          "name": "Ethan Lovei",
          "country": "France"
        },
        {
          "rank": 5,
          "name": "Josh Nicholas",
          "country": "Philippines"
        },
        {
          "rank": 6,
          "name": "Kevin Palko",
          "country": "USA"
        },
        {
          "rank": 7,
          "name": "Ivan Portela",
          "country": "Spain"
        }
      ],
      "left": [
        {
          "rank": 1,
          "name": "",
          "country": "",
          "vacant": true
        }
      ]
    }
  }
];
